import { SchedulerTruck } from '@numeo/types-core'

/** Any object that can identify a truck (scheduler truck, ELD truck, etc.) */
type TruckIdSource = { _id?: string | { toString(): string }; id?: string; appTruckId?: string }

/**
 * Returns a canonical truck id string. Handles _id (Mongo/backend), appTruckId (ELD), and id.
 */
export function getTruckId(truck: SchedulerTruck | TruckIdSource | null | undefined): string {
    if (!truck) return ''
    const src = truck as TruckIdSource
    const value = src._id ?? src.appTruckId ?? src.id
    return value != null ? String(value) : ''
}
